import React, { useState } from "react";
import { Link, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    buttonRounded: {
        borderRadius: "30px",
        textTransform: "none",
        height: "40px",
        margin: "5px",
        [theme.breakpoints.down("lg")]: {
            fontSize: "0.675rem",
            alignSelf: "center",
        },
    }
  })
);


export default function ShareButton(props) {
    const classes = useStyles();
    let [shareButtonText, setShareButtonText] = useState("Share")

    const shareText = () => {
        const text = `Provide this URL to share without any logins or apps required!
        ${window.location.href}`
        navigator.clipboard.writeText(text)
        setShareButtonText("Copied!")
        setTimeout(() => {
            setShareButtonText("Share")
        }, 1500);
    }
    return (
    <Button variant="outlined" className={classes.buttonRounded} onClick={shareText}>
    <Link  
        underline="none" 
        variant="body1"
        className={classes.link}
    >
        {shareButtonText}
    </Link>
    </Button>
    );
  };